import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ScreenNodeStatus',
  props: {
    online: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  online: boolean;
};



const galaNodeLink = process.env.galaNodeUrl;

return { __sfc: true,props, galaNodeLink }
}

})